import { createEnumOptions } from '../shared/enum-option.interface';

export interface IServicePort {
  id: string;
  state?: SpStat | string;
  sVlanId?: string;
  upTrafficProfile?: string;
  downTrafficProfile?: string;
  gemPortId?: string;
  userVlanId?: string;
  cVlanId?: string;
  svpid?: string;
}

export interface IServicePortDetail {
  spstat?: SpStat | string;
  remotedesc?: string;
  innervlanid?: string;
}

export interface IServicePortCombined
  extends IServicePort,
    IServicePortDetail {}

export enum SpStat {
  active = 'Active',
  activating = 'Activating',
}

export const spStatOptions = createEnumOptions({
  [SpStat.active]: {
    label: 'Active',
    color: 'success',
  },
  [SpStat.activating]: {
    label: 'Activating',
    color: 'warn',
  },
  _default: {
    label: '-',
    color: 'none',
  },
});
